const verticalTabsSections = document.querySelectorAll("section.vertical-tabs");
verticalTabsSections.forEach((section, i) => {
  // console.log("section", section);
  const items = section.querySelectorAll(".vt-list li"),
    imageTag = section.querySelector(".vt-content-desktop img"),
    headingTag = section.querySelector(".vt-content-desktop h3"),
    content = section.querySelector(".vt-content-desktop .richtext"),
    buttonLink = section.querySelector(".vt-content-desktop .button-link");

  let idx = 0,
    newtab;
  items.forEach((item, index) => {
    item.addEventListener("click", () => {
      console.log("item", item);
     if (idx == index) return;
      idx = index;
      items.forEach((i) => {
        i.classList.remove("active");
        //   const tab = item.querySelector(".vt-content-mobile");
        //   tab.style.height = "0px!important";
        //   tab.style.overflow = "hidden";
        // console.log("tab", tab);
      });
      item.classList.add("active");
      // if(window.innerWidth < 1024){
      // item
      // }
      const heading = item.querySelector(".heading").innerHTML;
      const paragraph = item.querySelector(".richtext").innerHTML;
      const btn = item.querySelector("a");
      if (btn) {
        const btnHref = item.querySelector("a").href;
        const btnTitle = item.querySelector("a").innerHTML;
        buttonLink.href = btnHref;
        buttonLink.innerHTML = btnTitle;
        buttonLink.parentNode.style.display = "inline-block";
      } else {
        buttonLink.parentNode.style.display = "none";
      }
      const image = item.querySelector("img").src;
      imageTag.src = image;
      headingTag.innerHTML = heading;
      content.innerHTML = paragraph;

      // const paragraph = caps[index].paragraph;
      // const image = caps[index].image;
      // imageTag.src = image;
      // content.innerHTML = paragraph;

      // mobile stuff
      // item.classList.add("active");
      // newtab = items[index].querySelector(".vt-content");
      // // console.log("newtab", newtab);
      // newtab.style.height = newtab.scrollHeight + "px";
      // newtab.style.overflow = "visible";

      // let isMobile = window.innerWidth < 1024;


    });
  });
});
